
<div class="padding-20 ui-g" id="c3_searchDistributionList_Modal">
 
    <div class="ui-dialog-footer fixed-buttons buttonsContainer">
      <button pButton (click)="onClickUndoSelection()" data-testid="basketCancelButton" type="button"
      class="k-generic-btn footer-btn" label="{{'common.cancel' | translate}}"></button>
    <button pButton type="button" (click)="onClickAddClusters()" data-testid="basketAddButton" type="button"
      class="k-generic-btn footer-btn" label="{{'common.add' | translate}}"></button>
    </div>
  <app-campaign-3-kontable 
  *ngIf="searchedClusters && show.table"
  id="distributionCluster"            
  [columns] = "[         
  { field: 'code', title: 'distributionList.code', filterType: textFilter },
  { field: 'description', title: 'distributionList.description', filterType: textFilter  },
  { field: 'startDate', title: 'distributionList.startDate',   type: 'date',
  filterType: dateFilter  },
  { field: 'endDate', title: 'distributionList.endDate',   type: 'date',
  filterType: dateFilter}
]"
 
  [paginationType]="paginationType"
  [showInfoButton]="false"            
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showRecoverButton]="false"
  [showAddButton]="false"
  [showDeleteButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [allowSelectRow]="false"
  [source]="searchedClusters"
  (onSelected)="onClusterElementSelected($event)"
  [showSelectButton]="true"
  #distributionListTable>

</app-campaign-3-kontable>  
 <br />
 <br />
 <br />
  
</div>






// WEBPACK FOOTER //
// ./src/app/views/distribution-list/search-distribution-cluster/search-distribution-cluster.component.html